import { Button, Modal } from "react-bootstrap";
import React from "react";

const LoginModal = ({ifShow, handleClickForSignIn}) => {
    return (
        <Modal
            show={ifShow}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title>Login</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
                <div style={{fontSize:"large"}} className="mt-4">Bitte melden Sie sich mit Ihrem ArcGIS-Enterprise-Konto an.</div>
                <div>
                    <Button id="sign-in" variant="dark" className="w-50 m-4"
                        onClick={handleClickForSignIn}>Anmelden
                    </Button>
                </div>


                <i>Probleme beim Einloggen? <a href="mailto: contact@ispaceplus.at" style={{ color: "#666666", textDecoration: "underline"}}>contact@ispaceplus.at</a></i>
                <div><img src={`${process.env.REACT_APP_BASE_URL}/ispace_plus_logo_600dpi.png`} alt="ispaceplus-logo" style={{ width: "15%", margin: "20px"}}/></div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <small className="text-muted">Entwickelt von iSPACE plus GmbH</small>
            </Modal.Footer>
        </Modal>
    )
}

export default LoginModal;
